import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Modal from 'react-modal';
import './import-campaign.scss';
import { DashboardHeader } from '../../atoms';
import { ImportCampaignContainer, DashContentFooter } from '../../molecules';
import { DashboardContext, UserContext } from '../../../context';
import { DashService } from '../../../services';

function ImportCampaign() {
  Modal.setAppElement('#root');
  const history = useHistory();
  const params = useParams();
  const [dashData, setDashData] = useState({});
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;


  useEffect(() => {
    //   getReportDetails();
  }, []);

  const handleBackClick = (event) => {
    history.push('/optimization');
  }

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className='row no-gutters'>
        <div className='no-gutters dash-left-wrapper'>
          <DashboardHeader />
          <ImportCampaignContainer handleBackClick={() => handleBackClick()}/>
          <DashContentFooter />
        </div>

      </div>

    </DashboardContext.Provider>
  );
}

export default ImportCampaign;
